import { TextField, TextFieldProps } from 'react-admin';

export const NullableTextField = (props: TextFieldProps) => (
  <TextField {...props} emptyText="--" />
);
